var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalSettingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Global_Settings_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Global_Settings_Active",
    "data-name": "Global Settings_Active",
    clipPath: "url(#clip-Global_Settings_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_10",
    "data-name": "Intersection 10",
    transform: "translate(1933 898)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1927-882a16.005,16.005,0,0,1,10-14.837A16.005,16.005,0,0,1-1907-882a16.005,16.005,0,0,1-10,14.837A16.005,16.005,0,0,1-1927-882Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -1917 -895.2049560546875 C -1919.403564453125 -894.1124267578125 -1921.4560546875 -892.3909301757812 -1922.96240234375 -890.1972045898438 C -1924.62255859375 -887.7796630859375 -1925.5 -884.9451293945312 -1925.5 -882 C -1925.5 -879.0548706054688 -1924.62255859375 -876.2203369140625 -1922.96240234375 -873.8027954101562 C -1921.4560546875 -871.609130859375 -1919.403564453125 -869.8875732421875 -1917 -868.7951049804688 C -1914.596435546875 -869.8875732421875 -1912.544067382812 -871.609130859375 -1911.037719726562 -873.8027954101562 C -1909.377563476562 -876.2203369140625 -1908.500122070312 -879.0548706054688 -1908.500122070312 -882 C -1908.500122070312 -884.9451293945312 -1909.377563476562 -887.7796630859375 -1911.037719726562 -890.1972045898438 C -1912.544067382812 -892.3909301757812 -1914.596435546875 -894.1124267578125 -1917 -895.2049560546875 M -1917 -896.8370361328125 C -1911.13623046875 -894.4633178710938 -1907.000122070312 -888.7145385742188 -1907.000122070312 -882 C -1907.000122070312 -875.2855224609375 -1911.13623046875 -869.5366821289062 -1917 -867.1630249023438 C -1922.863891601562 -869.5366821289062 -1927 -875.2855224609375 -1927 -882 C -1927 -888.7145385742188 -1922.863891601562 -894.4633178710938 -1917 -896.8370361328125 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_102",
    "data-name": "Subtraction 102",
    d: "M-1931.25-870.35h-1.5V-877h1.5v6.644Zm0-20.644h-1.5V-898h1.5v7Z",
    transform: "translate(1948 900)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_101",
    "data-name": "Subtraction 101",
    d: "M-1910.3-890.419h-7.475v-1.437c0-.021,0-.042,0-.063h7.478v1.5Zm-21.476,0H-1939v-1.5h7.226v1.5Z",
    transform: "translate(1940.775 906.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_103",
    "data-name": "Subtraction 103",
    d: "M-1928.186-896.5H-1939V-898h24.7v1.5h-10.5a.838.838,0,0,0-.792-.57h-1.786l-.011-.011a.833.833,0,0,0-.8.581Z",
    transform: "translate(1942.5 906.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_104",
    "data-name": "Subtraction 104",
    d: "M-1914.3-883.419H-1939v-1.5h10.746l.009.147a.844.844,0,0,0,.836.783h1.786a.833.833,0,0,0,.836-.783l.011-.147h10.474v1.5Z",
    transform: "translate(1942.5 906.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Streams_Settings",
    "data-name": "Streams Settings",
    transform: "translate(4.522 4.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_49",
    "data-name": "Subtraction 49",
    d: "M6.752,12.009H5.221a.724.724,0,0,1-.717-.672l-.035-.573a4.587,4.587,0,0,1-.752-.313l-.438.376A.739.739,0,0,1,2.8,11a.709.709,0,0,1-.51-.215L1.209,9.7a.722.722,0,0,1-.036-.985l.376-.43a5.03,5.03,0,0,1-.313-.761L.663,7.478A.728.728,0,0,1,0,6.752V5.221A.724.724,0,0,1,.672,4.5l.573-.036a4.587,4.587,0,0,1,.313-.752l-.376-.438a.724.724,0,0,1,.036-.985L2.3,1.209A.746.746,0,0,1,2.812,1a.729.729,0,0,1,.475.179l.429.376a5.012,5.012,0,0,1,.761-.313L4.522.672A.714.714,0,0,1,5.239,0l.009.009H6.779A.724.724,0,0,1,7.5.681l.036.573a4.587,4.587,0,0,1,.752.313l.439-.377a.737.737,0,0,1,.475-.17.709.709,0,0,1,.51.215l1.084,1.083a.724.724,0,0,1,.036.985l-.376.43a5.012,5.012,0,0,1,.313.761l.573.045A.728.728,0,0,1,12,5.266V6.8a.723.723,0,0,1-.672.716l-.573.036a4.594,4.594,0,0,1-.313.752l.377.438a.723.723,0,0,1-.036.985l-.546.538L9.69,10.8a.738.738,0,0,1-.511.206.726.726,0,0,1-.475-.179l-.43-.376a5.015,5.015,0,0,1-.761.313l-.045.573A.714.714,0,0,1,6.752,12.009Zm-.772-8.66a2.646,2.646,0,0,0,0,5.293H5.99a2.646,2.646,0,0,0,0-5.293Z",
    transform: "translate(5.478 5.263)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSettingsActive);
export default __webpack_public_path__ + "static/media/Global_Settings_Active.b482e8c43d63efcd2e3334b10fd693e7.svg";
export { ForwardRef as ReactComponent };